import { Controller } from "@hotwired/stimulus"

// Copies its `text` value to the clipboard and shows the `feedback` target for
// a moment. Knows nothing about what it copies (shared/_copy_emails is the one
// user). Where the browser refuses the clipboard (no secure context, old
// browser), the text opens in a prompt, titled by the clicked control's title.
// Contract: documentation/development_manual/copy-emails.md
const FEEDBACK_MS = 2000

export default class extends Controller {
  static values = { text: String }
  static targets = ["feedback"]

  disconnect() {
    clearTimeout(this.timer)
  }

  async copy(event) {
    // currentTarget is null once the handler has awaited
    const title = event.currentTarget.title

    try {
      await navigator.clipboard.writeText(this.textValue)
      this.showFeedback()
    } catch {
      window.prompt(title, this.textValue)
    }
  }

  showFeedback() {
    if (!this.hasFeedbackTarget) return

    this.feedbackTarget.hidden = false
    clearTimeout(this.timer)
    this.timer = setTimeout(() => (this.feedbackTarget.hidden = true), FEEDBACK_MS)
  }
}
